import { Controller } from 'stimulus'

export default class extends Controller {

  static targets = ['iframe', 'playButton', 'poster']

  toggle() {
    this.toggleElement(this.playButtonTarget)
    this.toggleElement(this.posterTarget)
    let src = this.iframeTarget.getAttribute('src')
    this.iframeTarget.setAttribute('src', `${src}?autoplay=1`)
    this.toggleElement(this.iframeTarget)
  }

  toggleElement(elem) {
    let showing = window.getComputedStyle(elem).display === 'block'
    elem.style.display = (showing) ? 'none' : 'block'
  }
}
